import statusbar from 'url:../../../assets/images/home-progress-0.webp';
import trainerProgramme1 from 'url:../../../assets/images/training-programme-1.webp';
import trainerProgramme3 from 'url:../../../assets/images/training-programme-3.webp';
import trainerProgramme4 from 'url:../../../assets/images/training-programme-4.webp';
import trainerProgramme5 from 'url:../../../assets/images/training-programme-5.webp';
import trainerProgramme6 from 'url:../../../assets/images/training-programme-6.webp';
import trainerProgramme7 from 'url:../../../assets/images/training-programme-7.webp';
import trainerProgramme8 from 'url:../../../assets/images/training-programme-8.webp';
import trainingWeeksCompleted from 'url:../../../assets/images/training-weeks-completed.webp';

export const trainingProgrammeAssets = {
  statusbar,
  trainerProgramme1,
  trainerProgramme3,
  trainerProgramme4,
  trainerProgramme5,
  trainerProgramme6,
  trainerProgramme7,
  trainerProgramme8,
  trainingWeeksCompleted,
} as const;

export const trainingProgrammeAssetList = Object.values(trainingProgrammeAssets);
